function FilterPanel({ children, onSubmit, onReset, layoutClassName, showApply = true }) {
  const gridClassName =
    layoutClassName ||
    'grid gap-2.5 md:grid-cols-2 xl:grid-cols-[minmax(0,1.2fr)_190px_190px_auto]';

  return (
    <form
      className="w-full min-w-0 max-w-full rounded-[18px] border border-[var(--theme-border)] bg-white p-3 shadow-[0_10px_24px_rgba(var(--theme-shadow-rgb),0.05)] sm:p-3.5"
      onSubmit={onSubmit}
    >
      <div className={`${gridClassName} min-w-0`}>
        {children}
        <FilterActions onReset={onReset} showApply={showApply} />
      </div>
    </form>
  );
}

function FilterActions({ onReset, showApply }) {
  return (
    <div className="grid min-w-0 gap-1.5 md:col-span-2 xl:col-span-1">
      <span className="text-[0.74rem] font-medium text-transparent">Actions</span>
      <div className="grid min-w-0 gap-1.5 sm:grid-cols-2 xl:flex">
        {showApply ? (
          <button
            className="min-h-[40px] whitespace-nowrap rounded-full border border-[var(--theme-accent)] bg-[var(--theme-accent)] px-4 py-2 text-[0.82rem] font-semibold text-white shadow-[0_8px_18px_rgba(var(--theme-shadow-rgb),0.16)] transition hover:border-[var(--theme-accent-strong)] hover:bg-[var(--theme-accent-strong)]"
            type="submit"
          >
            Apply Filters
          </button>
        ) : null}
        <button
          className="min-h-[40px] whitespace-nowrap rounded-full border border-[var(--theme-border)] bg-white px-4 py-2 text-[0.82rem] font-semibold text-[var(--theme-text-subtle)] shadow-[0_8px_18px_rgba(var(--theme-shadow-rgb),0.05)] transition hover:border-[var(--theme-accent)] hover:bg-[var(--theme-surface-soft)]"
          type="button"
          onClick={onReset}
        >
          Clear
        </button>
      </div>
    </div>
  );
}

export default FilterPanel;
